import {handleActions} from 'redux-actions';

import {
  RESET_BUSINESS_PROFILE,
  SET_BUSINESS_PROFILE_ERROR,
  SET_BUSINESS_PROFILE_IMAGE,
  SET_BUSINESS_PROFILE_IMAGE_ERROR,
  SET_BUSINESS_PROFILE_IMAGE_SAVING,
  SET_BUSINESS_PROFILE_LOADING,
  SET_BUSINESS_PROFILE_SAVING,
  SET_HEALTH_CARE_ERROR,
  SET_HEALTH_CARE_LOADING,
  SET_HEALTH_CARE_SAVING,
  SET_LEADS_POOL_ERROR,
  SET_LEADS_POOL_LOADING,
  SET_LEADS_POOL_SAVING,
  SET_SOCIAL_MEDIA_ERROR,
  SET_SOCIAL_MEDIA_LOADING,
  SET_SOCIAL_MEDIA_SAVING,
  SET_SUPPORTED_LANGUAGES_ERROR,
  SET_SUPPORTED_LANGUAGES_LOADING,
  SET_SUPPORTED_LANGUAGES_SAVING,
} from '/enum/request.enum';
import {SIGN_OUT} from '/redux/action/auth.action';
import {
  GET_ACCELERATOR_BONUS,
  GET_BONUSES,
  GET_BUSINESS_BUILDER_BONUS,
  GET_BUSINESS_BUILDER_BONUS_CONTRIBUTORS,
  GET_BUSINESS_PROFILE,
  GET_CSB_PLUS,
  GET_EDGE_365_CHALLENGE_TASKS,
  GET_HEALTH_CARE_DATA,
  GET_INCENTIVE_TRIP_BONUS,
  GET_LEADS_POOL,
  GET_PERFORMANCE,
  GET_PROFILE,
  GET_RANK_PROGRESSION,
  GET_SAME_DAY_LAST_MONTH,
  GET_SOCIAL_MEDIA,
  GET_SUPPORTED_LANGUAGES,
  GET_TEAMS,
  HIDE_RANK_PROGRESSION_DETAIL,
  RESET_COACH_PROFILE,
  RESET_EDGE_365_CHALLENGE_TASKS,
  SET_COACH_NOTES_STATE,
  SHOW_RANK_PROGRESSION_DETAIL,
} from '/redux/action/coach.action';
import {GET_INFO, SET_EARNINGS} from '/redux/action/currentUser.action';
import resetCoachProfile from '/redux/reducer/coach/resetCoachProfile';
import setNotesState from '/redux/reducer/coach/setNotesState';
import {withPayload} from '/util/reducer.util';

import authSignOut from './coach/auth/signOut';
import getBusinessProfile from './coach/businessProfile/getBusinessProfile';
import resetBusinessProfile from './coach/businessProfile/resetBusinessProfile';
import setBusinessProfileError from './coach/businessProfile/setBusinessProfileError';
import setBusinessProfileLoading from './coach/businessProfile/setBusinessProfileLoading';
import setBusinessProfileSaving from './coach/businessProfile/setBusinessProfileSaving';
import setBusinessProfileImage from './coach/businessProfileImage/setBusinessProfileImage';
import setBusinessProfileImageError from './coach/businessProfileImage/setBusinessProfileImageError';
import setBusinessProfileImageSaving from './coach/businessProfileImage/setBusinessProfileImageSaving';
import currentUserGetEarnings from './coach/currentUser/getEarnings';
import currentUserGetInfo from './coach/currentUser/getInfo';
import getEdge365ChallengeTasks from './coach/edge365/getEdge365ChallengeTasks';
import resetEdge365 from './coach/edge365/resetEdge365';
import getAcceleratorBonusBanner from './coach/getAcceleratorBonusBanner';
import currentUserGetBonuses from './coach/getBonuses';
import getBusinessBuilderBonusBanner from './coach/getBusinessBuilderBonusBanner';
import getBusinessBuilderBonusContributors from './coach/getBusinessBuilderBonusContributors';
import getCSBPlusBanner from './coach/getCSBPlusBanner';
import getIncentiveTripBonusBanner from './coach/getIncentiveTripBonusBanner';
import getInfo from './coach/getInfo';
import getPerformance from './coach/getPerformance';
import getRankProgression from './coach/getRankProgression';
import getSameDayLastMonth from './coach/getSameDayLastMonth';
import getTeams from './coach/getTeams';
import getHealthcareDataReducer from './coach/healthcareData/getHealthcareData';
import setHealthcareDataError from './coach/healthcareData/setHealthcareDataError';
import setHealthcareDataLoading from './coach/healthcareData/setHealthcareDataLoading';
import setHealthcareDataSaving from './coach/healthcareData/setHealthcareDataSaving';
import hideRankProgressionDetail from './coach/hideRankProgressionDetail';
import getLeadsPool from './coach/leadsPool/getLeadsPool';
import setLeadsPoolError from './coach/leadsPool/setLeadsPoolError';
import setLeadsPoolLoading from './coach/leadsPool/setLeadsPoolLoading';
import setLeadsPoolSaving from './coach/leadsPool/setLeadsPoolSaving';
import showRankProgressionDetail from './coach/showRankProgressionDetail';
import getSocialMedia from './coach/socialMedia/getSocialMedia';
import setSocialMediaError from './coach/socialMedia/setSocialMediaError';
import setSocialMediaLoading from './coach/socialMedia/setSocialMediaLoading';
import setSocialMediaSaving from './coach/socialMedia/setSocialMediaSaving';
import getSupportedLanguages from './coach/supportedLanguages/getSupportedLanguages';
import setSupportedLanguagesError from './coach/supportedLanguages/setSupportedLanguagesError';
import setSupportedLanguagesLoading from './coach/supportedLanguages/setSupportedLanguagesLoading';
import setSupportedLanguagesSaving from './coach/supportedLanguages/setSupportedLanguagesSaving';

const initialState = {
  allProfiles: {},
  coachCompetencies: {},
  rankProgressions: {},
  rankProgressionDetailVisibilities: {},
  allPerformances: {},
  allTeams: {},
  allEarnings: {},
  CABBanner: {},
  sameDayLastMonth: {},
  acceleratorBonusBanner: {},
  CSBPlusBanner: {},
  incentiveTripBonusBanner: {},
  bonuses: {},
  allNotesState: {},
  BBBBanner: {},
  BBBContributors: {},
  edge365: {},
  businessProfile: {
    data: {},
    isLoading: true,
    isSaving: false,
    hasError: false,
  },
  socialMedia: {
    data: [],
    isLoading: true,
    isSaving: false,
    hasError: false,
  },
  leadsPool: {
    data: null,
    isLoading: false,
    isSaving: false,
    hasError: false,
  },
  healthcare: {
    data: {},
    isLoading: false,
    isSaving: false,
    hasError: false,
  },

  supportedLanguages: {
    data: [],
    isLoading: false,
    isSaving: false,
    hasError: false,
  },
  businessProfileImage: {
    avatar: {
      url: '',
      isSaving: false,
      hasError: false,
    },
    before: {
      url: '',
      isSaving: false,
      hasError: false,
    },
    after: {
      url: '',
      isSaving: false,
      hasError: false,
    },
  },
};

export default handleActions(
  {
    [GET_INFO]: withPayload(currentUserGetInfo),
    [SET_EARNINGS]: withPayload(currentUserGetEarnings),
    [SIGN_OUT]: withPayload(authSignOut),
    [GET_RANK_PROGRESSION]: withPayload(getRankProgression),
    [GET_PERFORMANCE]: withPayload(getPerformance),
    [GET_PROFILE]: withPayload(getInfo),
    [GET_TEAMS]: withPayload(getTeams),
    [GET_ACCELERATOR_BONUS]: withPayload(getAcceleratorBonusBanner),
    [GET_CSB_PLUS]: withPayload(getCSBPlusBanner),
    [GET_SAME_DAY_LAST_MONTH]: withPayload(getSameDayLastMonth),
    [SHOW_RANK_PROGRESSION_DETAIL]: withPayload(showRankProgressionDetail),
    [HIDE_RANK_PROGRESSION_DETAIL]: withPayload(hideRankProgressionDetail),
    [GET_BONUSES]: withPayload(currentUserGetBonuses),
    [GET_INCENTIVE_TRIP_BONUS]: withPayload(getIncentiveTripBonusBanner),
    [GET_BUSINESS_BUILDER_BONUS]: withPayload(getBusinessBuilderBonusBanner),
    [RESET_COACH_PROFILE]: withPayload(resetCoachProfile),
    [SET_COACH_NOTES_STATE]: withPayload(setNotesState),
    [GET_BUSINESS_BUILDER_BONUS_CONTRIBUTORS]: withPayload(
      getBusinessBuilderBonusContributors,
    ),
    [GET_EDGE_365_CHALLENGE_TASKS]: withPayload(getEdge365ChallengeTasks),
    [RESET_EDGE_365_CHALLENGE_TASKS]: withPayload(resetEdge365),
    [GET_BUSINESS_PROFILE]: withPayload(getBusinessProfile),
    [SET_BUSINESS_PROFILE_LOADING]: withPayload(setBusinessProfileLoading),
    [SET_BUSINESS_PROFILE_SAVING]: withPayload(setBusinessProfileSaving),
    [SET_BUSINESS_PROFILE_ERROR]: withPayload(setBusinessProfileError),
    [RESET_BUSINESS_PROFILE]: withPayload(resetBusinessProfile),
    [GET_SOCIAL_MEDIA]: withPayload(getSocialMedia),
    [SET_SOCIAL_MEDIA_LOADING]: withPayload(setSocialMediaLoading),
    [SET_SOCIAL_MEDIA_SAVING]: withPayload(setSocialMediaSaving),
    [SET_SOCIAL_MEDIA_ERROR]: withPayload(setSocialMediaError),
    [GET_LEADS_POOL]: withPayload(getLeadsPool),
    [SET_LEADS_POOL_LOADING]: withPayload(setLeadsPoolLoading),
    [SET_LEADS_POOL_SAVING]: withPayload(setLeadsPoolSaving),
    [SET_LEADS_POOL_ERROR]: withPayload(setLeadsPoolError),
    [GET_HEALTH_CARE_DATA]: withPayload(getHealthcareDataReducer),
    [SET_HEALTH_CARE_LOADING]: withPayload(setHealthcareDataLoading),
    [SET_HEALTH_CARE_SAVING]: withPayload(setHealthcareDataSaving),
    [SET_HEALTH_CARE_ERROR]: withPayload(setHealthcareDataError),
    [GET_SUPPORTED_LANGUAGES]: withPayload(getSupportedLanguages),
    [SET_SUPPORTED_LANGUAGES_LOADING]: withPayload(
      setSupportedLanguagesLoading,
    ),
    [SET_SUPPORTED_LANGUAGES_SAVING]: withPayload(setSupportedLanguagesSaving),
    [SET_SUPPORTED_LANGUAGES_ERROR]: withPayload(setSupportedLanguagesError),
    [SET_BUSINESS_PROFILE_IMAGE]: withPayload(setBusinessProfileImage),
    [SET_BUSINESS_PROFILE_IMAGE_SAVING]: withPayload(
      setBusinessProfileImageSaving,
    ),
    [SET_BUSINESS_PROFILE_IMAGE_ERROR]: withPayload(
      setBusinessProfileImageError,
    ),
  },
  initialState,
);
